<template>
	<div class="osBody" style="overflow: auto;height: 100%;">
        <el-input size="small" placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
		<el-tree
			:data="treeData"
			:props="defaultProps"
			:default-expanded-keys="defaultExpandedKeys"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            :show-checkbox="showCheckBox"
			accordion
            node-key="id"
			highlight-current
            lazy
            v-loading="treeDataLoading"
            :load="loadChildren"
            ref="tree"
            @check-change="handleCheckChange" 
			@node-click="chooseNode"
		>
		</el-tree>
	</div>
</template>

<script>
import { get, post } from "@/assets/common/request";
export default {
	// inheritAttrs: false,
	name: "LeftProjectTree",
    props: {
        showCheckBox: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 互斥节点的level
        mutexLevel: {
            type: Number,
            default: function () {
                return 1;
            }
        },
    },
	data() {
		return {
            treeDataLoading: false,
			treeData: [],
            filterText: "",
			defaultExpandedKeys: [],
			defaultProps: {
				value: "id", // 唯一标识
				label: "label", // 标签显示
				children: "children", // 子级
                isLeaf: (data, node) => {
                    return (!node.data.children || node.data.children.length == 0 || node.level == 2) && node.level != 1
                }
			},
		};
	},
	methods: {
		chooseNode(nodeData, node, treeComponent) {
            if(node.level == 2) {
                const data = {
                    projectId: node.data.id,
                    projectName: node.data.label
                };
				this.$emit("chooseNode", data);
            }
		},
        handleCheckChange(data, checked, indeterminate) {
            const keys = this.$refs.tree.getCheckedKeys();
            this.$emit("checkNode", keys);
        },
		loadTreeData() {
            this.treeDataLoading = true;
			const url = this.$requestUrl.GET_FLOOR_TREE;
			get(url)
            .then((data) => {
				this.treeData = data.data;
			})
            .finally(() => {
                this.treeDataLoading = false;
            });
		},
        loadChildren(node, resolve) {
            if(node.data.children) {
                return resolve(node.data.children);
            }
            return resolve([]);
        },
		filterNode(value, data, node) {
			if (!value) return true;
			return node.label.indexOf(value) !== -1;
		},
	},
	watch: {
		treeData: {
			handler() {
				this.treeData.forEach((item) => {
					this.defaultExpandedKeys.push(item.id);
				});
			}
		},
        filterText(val) {
            setTimeout(() => {
                this.$refs.tree.filter(val);
            }, 500); 
        },
	},
	mounted() {
		this.loadTreeData();
	},
};
</script>

<style scoped lang="scss">
.osBody {
	width: 220px;
	height: 500px;
	float: left;
	margin-right: 1%;
	overflow-y: scroll;
}
</style>
